<template>
    <!-- Page Wrapper -->
    <div id="wrapper">

        <!-- Sidebar -->
        <the-sidebar />
        <!-- End of Sidebar -->

        <!-- Content Wrapper -->
        <div id="content-wrapper" class="d-flex flex-column">

            <!-- Main Content -->
            <div id="content">

                <!-- Topbar -->
                <the-topbar />
                <!-- End of Topbar -->

                <!-- Begin Page Content -->
                <router-view />
                <!-- /.container-fluid -->

            </div>
            <!-- End of Main Content -->

            <!-- Footer -->
            <the-footer />
            <!-- End of Footer -->

        </div>
        <!-- End of Content Wrapper -->        

    </div>
    <!-- End of Page Wrapper -->
</template>

<script>
    export default {
        name: 'master-layout'
    }

</script>